import { css } from '@emotion/core'
import React from 'react'

import { translate } from '../helpers/header'
import { Entry, HeaderNavigationProps } from '../interfaces/header'
import { Button } from './Button'
import { emojiStyle, entryLinkStyle } from './Header'
import { Link } from './Link'
import SearchBar from './Search'

const HeaderNavigation: React.FC<HeaderNavigationProps> = ({
  distractionFreeMode,
  withNavigation,
  isDark = false,
  styles,
  onClick,
  groups,
  isDropdownOpen,
  onDropdownClick,
  dropdown,
  getChevronIcon,
  search = '',
  setSearch = () => {},
  searchPlaceholder,
}) => {
  return (
    <React.Fragment>
      {groups
        .filter((g) => !distractionFreeMode || g.entries.some((e: Entry) => !!e.showInDistractionFreeMode))
        .filter((g) => withNavigation || g.alias !== 'navigation')
        .map((group, groupIndex, filteredGroups) => (
          <div
            key={groupIndex}
            css={[
              groupStyle(group.breakPoint),
              groupIndex === filteredGroups.length - 1 &&
                css`
                  justify-content: end;
                `,
            ]}
          >
            {group.entries
              .filter((e: Entry) => !distractionFreeMode || !!e.showInDistractionFreeMode)
              .map((entry: Entry, entryIndex: number) => (
                <div key={entryIndex} css={entryStyle}>
                  {entry.type === 'button' && (
                    <div>
                      <Button
                        type="primary"
                        className={entry.buttonClassName}
                        link={translate(entry.url)}
                        onClick={onClick(entry)}
                        css={buttonStyle(entry.buttonType)}
                      >
                        <p className="strong-body-2">{translate(entry.label)}</p>
                      </Button>
                    </div>
                  )}
                  {entry.type === 'link' ||
                    (entry.type === undefined && (
                      <React.Fragment>
                        <Link
                          href={translate(entry.url)}
                          onClick={onClick(entry)}
                          className="strong-body-2"
                          css={[entryLinkStyle(isDark), entry.style, styles?.entryLinkStyle]}
                        >
                          {entry.emoji && <p css={emojiStyle}>{entry.emoji}</p>}
                          {translate(entry.label)}
                        </Link>
                      </React.Fragment>
                    ))}
                  {entry.type === 'search' && (
                    <SearchBar isPartOfHeader placeholder={searchPlaceholder} search={search} setSearch={setSearch} />
                  )}
                  {entry.type === 'dropdown' && (
                    <React.Fragment>
                      <Link
                        onClick={onDropdownClick(entry)}
                        css={[entryLinkStyle(isDark, translate(entry.label) === dropdown?.name && isDropdownOpen)]}
                        className="strong-body-2"
                      >
                        {translate(entry.label)}
                        {getChevronIcon(entry)}
                      </Link>
                    </React.Fragment>
                  )}
                </div>
              ))}
          </div>
        ))}
    </React.Fragment>
  )
}

export default HeaderNavigation

const groupStyle = (breakPoint: number) => css`
  display: grid;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  grid-template-rows: 1fr;
  grid-gap: 1rem;
  align-items: center;

  @media screen and (max-width: ${breakPoint}px) {
    display: none;
  }
`

const entryStyle = css`
  text-align: center;
  display: inline-block;
`

const buttonStyle = (buttonType?: string) => css`
  color: #fff;
  padding: ${buttonType === 'ghost' ? 'calc(0.5rem - 2px) 1rem' : '0.5rem 1.37rem'};
`
